import * as angular from 'angular';
import * as moment from 'moment';
import {IController, ILogService, IWindowService} from "angular";
import {Expense} from "../../../expenses/models/expenses.model";
import {DeliveriesDialogService} from "../../services/deliveries-dialog-service.service";
import {DeliveriesService} from "../../services/deliveries-service.service";
import {ServicesService} from "../../services/services-service.service";
import {CommissionsDialogService} from "../../../commissions/services/commissions-dialogs-service.service";
import {CommissionsService} from "../../../commissions/services/commissions-service.service";
import {ProNumberDialogService} from "../../../commons/services/pro-number-dialog-service.service";
import {SiteContextService} from "../../../commons/services/site-context.service";
import * as _ from "lodash";
import {SplitService} from "../../../commons/services/split-service.service";
import {ExpensesDialogService} from "../../../expenses/services/expenses-dialog.service";
import {ExpensesService} from "../../../expenses/services/expenses-service.service";
import {ExpenseStatus} from "../../../expenses/types/expenses-status.type";
import {take} from "rxjs";
import {TimeCardModel} from "../../../timekeeping/angular/models";
import {TimekeepingHttpService} from "../../../timekeeping/angular/services/timekeeping-http.service";
import {resolveFieldValue} from "../../../timekeeping/utils/field.util";

export class DeliveryDetailPanelCtrl implements IController {
  delivery: any;
  isBackInStore: any;
  hasRevertedTask: boolean;
  onBackInStore: Function;

  public siteInfo: boolean;
  public priceDisableByStatus: any;
  private openInfoSection: any;
  private programTypesMap: any;
  private configZoneId: any;
  private serviceAreasIds: any;
  public showEditOmsOrderButton: boolean;
  public totalExpensesPrice: number;
  public canCreateTag: boolean;
  public deliveryCopy?: any;
  public expenses?: Expense[];
  public expensesImagesUrlsMap: any;
  public isExposeAgentBranches: boolean;
  public expenseStatusesTypes: typeof ExpenseStatus = ExpenseStatus;
  public isShowEditOrderButton: boolean;
  public isShowEditBranchesButton: boolean;
  public latestTimecard: TimeCardModel | undefined = undefined;
  public timecardLink: string = ``;


  /* @ngInject */
  constructor(private splitService: SplitService,
              private $mdMedia,
              private $mdSidenav,
              private deliveriesService: DeliveriesService,
              private $state,
              private $window: IWindowService,
              private commissionsDialogService: CommissionsDialogService,
              private deliveriesDialogService: DeliveriesDialogService,
              private commissionsService: CommissionsService,
              private deliveriesConstants, private $log: ILogService,
              private proNumberDialogService: ProNumberDialogService,
              private siteContextService: SiteContextService,
              private servicesService: ServicesService,
              private timekeepingHttpService: TimekeepingHttpService,
              private IAMPermissions,
              private expensesDialogService: ExpensesDialogService,
              private expensesService: ExpensesService) {
    this.siteInfo = this.siteContextService.getSiteInfo();
  }

  $onInit() {
    if (this.IAMPermissions.hasPermission('expenses.list')) {
      this._getServiceExpenses(this.delivery.id);
    }
    this.openInfoSection = !this.$mdMedia('xs');
    this.programTypesMap = this.splitService.getSiteProgramTypesMap();
    this.configZoneId = this.splitService.getTimeZone();
    this.isExposeAgentBranches = this.splitService.getExposeAgentBranchesOnTheService();
    this.serviceAreasIds = this.deliveriesService.getDeliveryServiceAreasIdsList(this.delivery);
    this.canCreateTag = this.IAMPermissions.hasPermission('infoTags.create');
    this.priceDisableByStatus = this.deliveriesConstants.editPriceDisableByStatus;

    if (this.IAMPermissions.hasPermission('timekeeping.timeCard.list')) {
      this._loadLatestTimecard();
    }
  }

  $doCheck() {
    this.showEditOmsOrderButton = !this.$state.$current.includes['service.edit-delivery'];
  };

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  collapseInfoSection(event) {
    event.stopPropagation();
    this.openInfoSection = !this.openInfoSection;
  }

  toggleSidenav(event) {
    this.$mdSidenav('deliveryDetailNav').toggle();
  }

  onEditOrder(orderId) {
    const siteId = this.splitService.getSiteId();
    const url = this.$state.href('order.edit', {id: orderId, siteId: siteId});
    this.$window.open(url, '_blank', 'width=1500,,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
  }

  onEditBilling() {
    this.deliveriesService.getDeliveryBilling(this.delivery.id)
      .then((billing) => {
        return this.deliveriesDialogService.editServiceBilling(this.delivery.id, billing)
      })
      .then((editedBilling) => {
        this._updateServiceBilling(editedBilling);
      })
      .catch((err) => {
        this.$log.info('Dialog Closed', err);
      })
  }

  onEditCommissionPrice(commissionId) {
    this.commissionsDialogService.editPrice()
      .then((payload) => {
        this.commissionsService.editPrice(commissionId, payload.price, payload.comment);
      })
  }

  onEditProNumber() {
    this.proNumberDialogService.editProNumberDialog(this.delivery.proNumber, true)
      .then((editedProNumber) => {
        this._updateServiceProNumber(editedProNumber);
      })
      .catch((err) => {
        this.$log.info('Dialog Closed', err);
      })
  }

  onEditTags() {
    this.deliveryCopy = angular.copy(this.delivery);
  }

  onCancelEditTags() {
    this.deliveryCopy = undefined;
  }

  onTagsChange(tagNames) {
    this.deliveryCopy.tagNames = tagNames;
  }

  onUpdateTags(form) {
    if (form) {
      form.$setSubmitted(true);
      if (form.$valid) {
        this.servicesService.updateCompletedService(this.delivery.id, this.deliveryCopy)
          .then((res) => {
            this.delivery = res;
          })
          .finally(() => {
            this.deliveryCopy = undefined;
          })
      }
    }
  }

  onEditExpense(expense, index, event) {
    this.expensesDialogService.editExpense(expense, event)
      .then((expense) => {
        this._updateExpense(expense, index);
      })
      .catch((error) => {
        if (error) {
          this.$log.error('Failed to edit expense', error);
        } else {
          this.$log.debug('Dialog Closed');
        }
      })
  }

  onEditReferenceIds(referenceIds, event) {
    this.deliveriesDialogService.editReferenceIds(referenceIds, this.delivery.omsOrderReference?.id, event)
      .then((payload: { referenceIds: string[], updateOrder: boolean }) => {
        this._editReferenceIds(payload.referenceIds, payload.updateOrder);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  ///// private methods ////

  private _updateServiceBilling(billing) {
    this.deliveriesService.updateServiceBilling(this.delivery.id, billing)
      .catch((error) => {
        this.$log.info('Failed to update service billing', error);
      })
  }

  private _updateServiceProNumber(proNumber: string) {
    if (this.delivery.proNumber === proNumber) return;

    let deliveryCopy = angular.copy(this.delivery);
    deliveryCopy.proNumber = proNumber;
    this.deliveriesService.updateServiceProNumber(deliveryCopy)
      .catch((error) => {
        this.$log.info('Failed to update service PRO number', error);
      })
  }

  private _getServiceExpenses(deliveryId: string) {
    this.expensesImagesUrlsMap = {};
    this.servicesService.getServiceExpenses(deliveryId)
      .then((expenses: Expense[]) => {
        if (expenses.length) {
          this.expenses = expenses;

          this.expenses?.forEach(e => {
            this.expensesImagesUrlsMap[e.id] = e.attachments;
          })
          this.totalExpensesPrice = expenses.reduce((sum, expense) => sum + expense.price, 0);
        }
      })
  }

  private _updateExpense(expense, index) {
    this.expensesService.updateExpense(expense)
      .then((updatedExpense) => {
        this.expenses[index] = updatedExpense;
      })
  }

  private _editReferenceIds(referenceIds: string[], updateOrder?: boolean) {
    this.servicesService.updateReferenceIds(this.delivery.id, referenceIds, updateOrder)
      .then((updatedService) => {
        this.delivery = updatedService;
      })
  }

  private _loadLatestTimecard() {
    const timeCardIds: Set<string> = this.delivery.taskList.reduce((ids, task) => {
      if (task.timeCardId) {
        ids.add(task.timeCardId);
      }
      return ids;
    }, new Set<string>());

    if (!!timeCardIds.size) {
      this.timekeepingHttpService
        .getTimeCards({ ids: Array.from(timeCardIds), limit: timeCardIds.size })
        .pipe(take(1))
        .subscribe((timecards: { list: TimeCardModel[] }) => {
          if (!timecards || !timecards.list || timecards.list.length === 0) {
            this.latestTimecard = undefined;
          } else {
            this.latestTimecard = timecards.list.reduce((latest, current) => {
              return current.updatedAt > latest.updatedAt ? current : latest;
            });

            const date = resolveFieldValue(this.latestTimecard.clockInTimeField);
            const fromDate = moment(date).startOf('day').valueOf();
            const toDate = moment(date).endOf('day').valueOf();

            this.timecardLink = `timecardDetail({ agentId: "${this.latestTimecard.agentId}", from: "${fromDate}", to: "${toDate}" })`;
          }
        });
    }

  }
}

angular
  .module('bringoz.admin.deliveries')
  .component('deliveryDetailPanel', {
    bindings: {
      delivery: '<',
      isBackInStore: '<',
      hasRevertedTask: '<',
      onBackInStore: '&',
      onUpdateBranches: '&'
    },
    template: require('./delivery-detail-panel.html').default,
    controller: DeliveryDetailPanelCtrl
  });
